import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({ providedIn: "root" })
export class ServiceProviderService {
  constructor(private http: HttpClient) {}

  getServiceProviders(): Observable<any> {
    return this.http.get(
      `${environment.apiBaseAddress}ServiceProvider`,
      httpOptions
    );
  }

  getServiceProvidersByTenant(tenantId: string): Observable<any> {
    return this.http.get(
      `${environment.apiBaseAddress}ServiceProvider/Tenant/${tenantId}`,
      httpOptions
    );
  }
}
